import React from 'react'
import { Box, Chip } from '@mui/joy'
import { CellCountableMore } from './';

const CellNameAndColorList = ({ value, limit = 2 }) => {
    if (!Array.isArray(value) && value) {
        value = [value];
    } else if (value == null) {
        value = [];
    }
    const length = (value) ? Object.keys(value).length : 0;

    return (
        <Box className={'list-element-cell cell-generics cell-color cell-name-and-color'}>
            {
                value && value.map((item, k) => {
                    if (k >= limit || item == null) return;
                    return (
                        <Chip className="" sx={{boxShadow:'0 0 2px #00000030', backgroundColor:'white',border:'1px solid #00000020'}}>
                            <span className="color-dot" style={{ backgroundColor: item.color, marginRight:'5px', transform:'translateY(1px)' }} ></span>
                            <span className="name" style={{fontSize:'12px',lineHeight:'20px'}}>{item.name}</span>
                        </Chip>
                    );
                })
            }
            <CellCountableMore limit={limit} length={length} />
        </Box>
    )
}

export default CellNameAndColorList